import {isNonEmpty} from 'web-app/util/non-empty-array';

export const getAutomaticRuleGroupId = (ruleGroupOptions: Array<{label: string; value: string}>): string | null => {
    if (!isNonEmpty(ruleGroupOptions)) {
        return null;
    }

    const automaticRuleGroup = ruleGroupOptions.find(
        // Automatic rule group sometimes does not have a label, so we find the first one without a label
        // If multiple rule groups are missing labels, the first one will be used
        // TODO: In case of multiple rule groups without labels, we should not send an automatic pricing group option to the chill bill modal
        ruleGroup => ruleGroup.label === 'Automatic' || ruleGroup.label === '',
    );

    return automaticRuleGroup?.value ?? null;
};
